import { FunctionComponent, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Backdrop, CircularProgress, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import get from 'lodash/get';

import { useNavigateToRoute } from '../../../../shared/hooks/use-navigate-to-route/use-navigate-to-route.hook';
import { globalTheme } from '../../../../shared/theme/theme';
import { useAppSelector } from '../../../../store/store';
import { ROOT } from '../../../../store/utils/files-names';
import { navbarHeight } from '../../styles/variables/sizes';
import ChangeDetectorContextProvider from '../change-detector-context/ChangeDetectorContext';
import ModalContextProvider from '../modal/ModalContext';
import Container from '../ui/Container/Container';
import Grid from '../ui/Grid/Grid';
import SidebarMenu from '../ui/SidebarMenu/SidebarMenu';
import TopBar from '../ui/TopBar/TopBar';

const Layout: FunctionComponent = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const isLoading = useAppSelector(state => get(state, ROOT).isLoading);
  const isApkUploadLoading = useAppSelector(
    state => get(state, ROOT).isApkUploadLoading
  );
  const areAppIconsLoading = useAppSelector(
    state => get(state, ROOT).areAppIconsLoading
  );

  const location = useLocation();
  const navigateToApps = useNavigateToRoute('appstore/all-apps');

  useEffect(() => {
    if (location.pathname === '/') {
      navigateToApps();
    }
  }, []);

  const menuStateChangeHandler = (isOpen: boolean): void => {
    setIsMenuOpen(isOpen);
  };

  return (
    <>
      <Container
        maxWidth={false}
        sx={{
          height: '100%',
          flexGrow: '1',
          '.svg-icon': {
            fill: globalTheme.palette.primary.main,
            g: {
              fill: globalTheme.palette.primary.main,
            },
          },
        }}
        component={'div'}
        disableGutters={true}
      >
        <Grid
          container
          sx={{
            position: 'relative',
          }}
        >
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            sx={{
              position: 'relative',
              height: navbarHeight,
            }}
          >
            <TopBar />
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            sx={{
              display: 'flex',
              position: 'relative',
            }}
          >
            <Backdrop
              sx={{
                position: 'fixed',
                zIndex: 10,
                color: globalTheme.palette.black.main,
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                top: 0,
                right: 0,
                height: '100vh',
                opacity: 0.3,
              }}
              open={isLoading || areAppIconsLoading}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <CircularProgress
                  sx={theme => ({ color: theme.palette.primary.main })}
                />
                <Typography sx={{ marginTop: 1 }}>Loading</Typography>
              </Box>
            </Backdrop>
            <ChangeDetectorContextProvider>
              <ModalContextProvider>
                <SidebarMenu propagateStateChange={menuStateChangeHandler} />

                <Container
                  component={'div'}
                  maxWidth={false}
                  sx={{
                    height: '100%',
                    overflow: 'hidden',
                    maxWidth: 'unset !important',
                    ml: 'unset',
                    mr: 'unset',
                    marginBottom: '64px',
                    paddingLeft: !isMenuOpen
                      ? '324px !important'
                      : '84px !important',
                  }}
                >
                  <Outlet />
                </Container>
              </ModalContextProvider>
            </ChangeDetectorContextProvider>
          </Grid>
        </Grid>
      </Container>

      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={isApkUploadLoading}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <CircularProgress
            sx={theme => ({ color: theme.palette.primary.main })}
          />
          <Typography sx={{ marginTop: 1 }}>Loading</Typography>
        </Box>
      </Backdrop>
    </>
  );
};

export default Layout;
